import { useEffect, useCallback, useContext, useRef } from "react";
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";

// export function useConfirmExit(confirmExit, when = true) {
//   const { navigator } = useContext(NavigationContext);

//   useEffect(() => {
//     console.log("confirm exit")
//     if (!when) return;

//     const push = navigator.push;

//     navigator.push = (...args) => {
//       const result = confirmExit();
//       if (result !== false) {
//         push(...args);
//       }
//     };

//     return () => {
//       navigator.push = push;
//     };
//   }, [navigator, confirmExit, when]);
// }

export function useConfirmExit(confirmExit, when = true) {
  const { navigator } = useContext(NavigationContext);
  const pushedRef = useRef(false);

  useEffect(() => {
    if (!when) return;

    const originalPush = navigator.push;
    navigator.push = (...args) => {
      const allow = confirmExit();
      if (allow) {
        originalPush(...args);
      }
    };

     // const handleBeforeUnload = (e) => {
    //   if (confirmExit()) {
    //     e.preventDefault();
    //     e.returnValue = "";
    //   }
    // };

   
    if (!pushedRef.current) {
      window.history.pushState({ guard: true }, "", window.location.href);
      pushedRef.current = true;
    }

    const handlePopState = () => {
      const allow = confirmExit();
      if (!allow) {
       
        window.history.pushState({ guard: true }, "", window.location.href);
      } else {
    
        cleanup();
        window.history.back();
      }
    };

    const cleanup = () => {
      navigator.push = originalPush;
      window.removeEventListener("popstate", handlePopState);
    };

    window.addEventListener("popstate", handlePopState);

    return cleanup;
  }, [navigator, confirmExit, when]);
}

// export default function usePrompt(message, when = true) {
//   useEffect(() => {
//     if (when) {
//       window.onbeforeunload = function() {
        
//         return message;
//       };
//       window.history.pushState(null, "", window.location.href);
//     }
//     // window.addEventListener("popstate", ()=> {
//     //   if (when) {
//     //     console.log("prompt ")
//     //     return message;
//     //     // window.history.pushState(null, "", window.location.href);
//     //   }
//     // })
//     return () => {
//       window.onbeforeunload = null;
//           // window.removeEventListener("popstate", ()=> {})

//     };
//   }, [message, when]);

//   const confirmExit = useCallback(() => {
//     const confirm = window.confirm(message);
//     return confirm;
//   }, [message]);
//   useConfirmExit(confirmExit, when);
// }

export default function usePrompt(message, when = true) {
  useEffect(() => {
    if (!when) return;
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = message;
      return message;    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [message, when]);

  const confirmExit = useCallback(() => {
    return window.confirm(message);
  }, [message]);

  useConfirmExit(confirmExit, when);
}